module.exports = __webpack_public_path__ + "img/h3.0e93833a.png";